import { z } from 'zod/mini'

/** 変換項目のzodスキーマ */
export const ConversionItemSchema = z.object({
  id: z.string(),
  before: z.string(),
  after: z.string(),
  display_order: z.optional(z.number())
})

/** @typedef {import('zod/mini').infer<typeof ConversionItemSchema>} ConversionItem */

/** 変換表メタデータのzodスキーマ */
export const ConversionTableMetaSchema = z.object({
  key: z.string(),
  name: z.string(),
  conversion_target: z.optional(z.string()),
  memo: z.optional(z.string()),
  display_order: z.number()
})

/** @typedef {import('zod/mini').infer<typeof ConversionTableMetaSchema>} ConversionTableMeta */

/** バリデーションエラーのzodスキーマ */
export const ValidationErrorSchema = z.object({
  rowIndex: z.number(),
  errorType: z.enum(['duplicate', 'invalid', 'invalid_category']),
  field: z.enum(['before', 'after']),
  value: z.optional(z.string()),
  message: z.optional(z.string())
})

/** @typedef {import('zod/mini').infer<typeof ValidationErrorSchema>} ValidationError */

/** DynamoDB変換表一覧レコードのzodスキーマ */
export const ConversionTableRowSchema = z.object({
  CorporationNumber: z.string(),
  SearchKey: z.string(),
  EntityType: z.string(),
  ConversionTableKey: z.optional(z.string()),
  ConversionTableName: z.optional(z.string()),
  ConversionTarget: z.optional(z.string()),
  ConversionTableRecordCount: z.optional(z.number()),
  ConversionTableDisplayOrder: z.optional(z.number()),
  ConversionTableMemo: z.optional(z.string())
})

/** @typedef {import('zod/mini').infer<typeof ConversionTableRowSchema>} ConversionTableRow */

/** 変更履歴レコードのzodスキーマ */
export const HistoryRowSchema = z.object({
  HistoryUpdateDateTime: z.optional(z.string()),
  HistoryUpdateUserName: z.optional(z.string()),
  HistoryConversionTableName: z.optional(z.string()),
  HistoryOperationType: z.optional(z.enum(['create', 'update', 'delete'])),
  HistoryDetail: z.optional(z.string())
})

/** @typedef {import('zod/mini').infer<typeof HistoryRowSchema>} HistoryRow */

/** API変換項目のzodスキーマ（IF02077レスポンス用） */
export const ApiConversionItemSchema = z.object({
  value_before: z.optional(z.string()),
  value_after: z.optional(z.string()),
  value_display_order: z.optional(z.number())
})

/** @typedef {import('zod/mini').infer<typeof ApiConversionItemSchema>} ApiConversionItem */

/** IF02077変換項目取得APIレスポンスのzodスキーマ */
export const GetConversionValuesResponseSchema = z.object({
  body: z.object({
    conversion_value_list: z.array(ApiConversionItemSchema)
  })
})

/** @typedef {import('zod/mini').infer<typeof GetConversionValuesResponseSchema>} GetConversionValuesResponse */

/** 変換表データのzodスキーマ（IF02076, IF02071リクエスト用） */
export const ConversionTableDataSchema = z.object({
  key: z.string(),
  name: z.string(),
  conversion_target: z.string(),
  memo: z.string(),
  display_order: z.number()
})

/** @typedef {import('zod/mini').infer<typeof ConversionTableDataSchema>} ConversionTableData */

/** IF02076, IF02071リクエストボディのzodスキーマ */
export const ConversionTableRequestSchema = z.object({
  conversion_table_data: ConversionTableDataSchema,
  is_delete: z.boolean(),
  conversion_table_items: z.array(ApiConversionItemSchema)
})

/** @typedef {import('zod/mini').infer<typeof ConversionTableRequestSchema>} ConversionTableRequest */

/** 区分一覧レコードのzodスキーマ（IF02078 API レスポンス用） */
export const ClassificationSchema = z.object({
  // IF02078 API レスポンスフィールド（snake_case）
  search_key: z.optional(z.string()),
  data_classification_name: z.optional(z.string()),
  data_classification_display_order: z.optional(z.number()),
  data_classification_description: z.optional(z.string()),
  standard_format_column_name: z.optional(z.string()),
  item_count: z.optional(z.number()),
  // 後方互換性のための旧フィールド（camelCase）
  ClassificationKey: z.optional(z.string()),
  SearchKey: z.optional(z.string()),
  DataClassificationName: z.optional(z.string()),
  DataClassificationDisplayOrder: z.optional(z.number())
})

/** @typedef {import('zod/mini').infer<typeof ClassificationSchema>} Classification */

/** 履歴操作タイプのラベル */
export const HISTORY_OPERATION_LABELS = {
  create: '新規追加',
  update: '更新',
  delete: '削除'
}

/** 履歴操作タイプのスタイル */
export const HISTORY_OPERATION_STYLES = {
  create: { bg: '#dcfce7', color: '#166534' },
  update: { bg: '#dbeafe', color: '#1e40af' },
  delete: { bg: '#fee2e2', color: '#991b1b' }
}
